// extracted by mini-css-extract-plugin
module.exports = {"parentTitle":"VIP_ActivityFamilyLine__parentTitle"};